import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 7H4C3.448 7 3 6.552 3 6V4C3 3.448 3.448 3 4 3H20C20.552 3 21 3.448 21 4V6C21 6.552 20.552 7 20 7Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 14H4C3.448 14 3 13.552 3 13V11C3 10.448 3.448 10 4 10H20C20.552 10 21 10.448 21 11V13C21 13.552 20.552 14 20 14Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 21H4C3.448 21 3 20.552 3 20V18C3 17.448 3.448 17 4 17H20C20.552 17 21 17.448 21 18V20C21 20.552 20.552 21 20 21Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
